<template>
  <div class="love-container">
    <!-- 原代码中的两个canvas元素 -->
    <canvas id="c"></canvas>
    <canvas id="pinkboard"></canvas>
  </div>
</template>

<script>
export default {
  name: "liveComponent",
  mounted() {
    document.title = "甜许";
    // 页面渲染完成后初始化两个动画（避免DOM未加载问题）
    this.initMatrixAnimation();
    this.initLoveAnimation();
  },
  methods: {
    // 1. 初始化数字雨动画（原第一个script逻辑）
    initMatrixAnimation() {
      const c = document.getElementById("c");
      const ctx = c.getContext("2d");
      // 适配窗口大小
      c.width = window.innerWidth;
      c.height = window.innerHeight;

      const string1 = "abcdefghijklmnopqrstuvwxyz";
      const fontsize = 20;
      const columns = c.width / fontsize;
      const drop = [];
      // 初始化雨滴位置
      for (let x = 0; x < columns; x++) {
        drop[x] = 0;
      }

      // 数字雨绘制函数
      function drap() {
        ctx.fillStyle = "rgba(0,0,0,0.07)"; // 背景透明度（可修改）
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.fillStyle = "#ea80b0"; // 数字颜色（可修改）
        ctx.font = `${fontsize}px arial`;
        for (let i = 0; i < drop.length; i++) {
          const text1 = string1[Math.floor(Math.random() * string1.length)];
          ctx.fillText(text1, i * fontsize, drop[i] * fontsize);
          drop[i]++;
          // 超出屏幕后重置（90%概率）
          if (drop[i] * fontsize > c.height && Math.random() > 0.9) {
            drop[i] = 0;
          }
        }
      }

      // 启动数字雨定时器
      setInterval(drap, 50);

      // 窗口 resize 时重新适配canvas大小
      window.addEventListener("resize", () => {
        c.width = window.innerWidth;
        c.height = window.innerHeight;
      });
    },

    // 2. 初始化爱心粒子动画（原第二个script逻辑）
    initLoveAnimation() {
      const canvas = document.getElementById("pinkboard");
      // const context = canvas.getContext("2d");

      // 1. 配置参数（可自定义调整）
      const settings = {
        particles: {
          length: 500, // 最大粒子数
          duration: 2, // 粒子存在时间（秒）
          velocity: 100, // 粒子速度（像素/秒）
          effect: -0.75, // 粒子运动效果系数
          size: 30, // 粒子大小（像素）
        },
      };

      // 2. RequestAnimationFrame 兼容性处理
      (function () {
        let lastTime = 0;
        const vendors = ["ms", "moz", "webkit", "o"];
        for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
          window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
          window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
        }
        if (!window.requestAnimationFrame) {
          window.requestAnimationFrame = function (callback) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(() => {
              callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
          };
        }
        if (!window.cancelAnimationFrame) {
          window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
          };
        }
      })();

      // 3. 点坐标类
      const Point = (function () {
        function Point(x, y) {
          this.x = typeof x !== "undefined" ? x : 0;
          this.y = typeof y !== "undefined" ? y : 0;
        }
        Point.prototype.clone = function () {
          return new Point(this.x, this.y);
        };
        Point.prototype.length = function (length) {
          if (typeof length === "undefined") {
            return Math.sqrt(this.x * this.x + this.y * this.y);
          }
          this.normalize();
          this.x *= length;
          this.y *= length;
          return this;
        };
        Point.prototype.normalize = function () {
          const length = this.length();
          this.x /= length;
          this.y /= length;
          return this;
        };
        return Point;
      })();

      // 4. 粒子类
      const Particle = (function () {
        function Particle() {
          this.position = new Point();
          this.velocity = new Point();
          this.acceleration = new Point();
          this.age = 0;
        }
        Particle.prototype.initialize = function (x, y, dx, dy) {
          this.position.x = x;
          this.position.y = y;
          this.velocity.x = dx;
          this.velocity.y = dy;
          this.acceleration.x = dx * settings.particles.effect;
          this.acceleration.y = dy * settings.particles.effect;
          this.age = 0;
        };
        Particle.prototype.update = function (deltaTime) {
          this.position.x += this.velocity.x * deltaTime;
          this.position.y += this.velocity.y * deltaTime;
          this.velocity.x += this.acceleration.x * deltaTime;
          this.velocity.y += this.acceleration.y * deltaTime;
          this.age += deltaTime;
        };
        Particle.prototype.draw = function (ctx, image) {
          // 缓动函数（使粒子大小/透明度渐变）
          function ease(t) {
            return --t * t * t + 1;
          }
          const size = image.width * ease(this.age / settings.particles.duration);
          ctx.globalAlpha = 1 - this.age / settings.particles.duration;
          ctx.drawImage(image, this.position.x - size / 2, this.position.y - size / 2, size, size);
        };
        return Particle;
      })();

      // 5. 粒子池类（复用粒子，优化性能）
      const ParticlePool = (function () {
        let particles;
        let firstActive = 0;
        let firstFree = 0;
        const duration = settings.particles.duration;

        function ParticlePool(length) {
          particles = new Array(length);
          for (let i = 0; i < particles.length; i++) {
            particles[i] = new Particle();
          }
        }
        ParticlePool.prototype.add = function (x, y, dx, dy) {
          particles[firstFree].initialize(x, y, dx, dy);
          // 循环队列处理
          firstFree++;
          if (firstFree === particles.length) firstFree = 0;
          if (firstActive === firstFree) firstActive++;
          if (firstActive === particles.length) firstActive = 0;
        };
        ParticlePool.prototype.update = function (deltaTime) {
          let i;
          // 更新活跃粒子
          if (firstActive < firstFree) {
            for (i = firstActive; i < firstFree; i++) {
              particles[i].update(deltaTime);
            }
          }
          if (firstFree < firstActive) {
            for (i = firstActive; i < particles.length; i++) {
              particles[i].update(deltaTime);
            }
            for (i = 0; i < firstFree; i++) {
              particles[i].update(deltaTime);
            }
          }
          // 移除过期粒子
          while (particles[firstActive].age >= duration && firstActive !== firstFree) {
            firstActive++;
            if (firstActive === particles.length) firstActive = 0;
          }
        };
        ParticlePool.prototype.draw = function (ctx, image) {
          let i;
          // 绘制活跃粒子
          if (firstActive < firstFree) {
            for (i = firstActive; i < firstFree; i++) {
              particles[i].draw(ctx, image);
            }
          }
          if (firstFree < firstActive) {
            for (i = firstActive; i < particles.length; i++) {
              particles[i].draw(ctx, image);
            }
            for (i = 0; i < firstFree; i++) {
              particles[i].draw(ctx, image);
            }
          }
        };
        return ParticlePool;
      })();

      // 6. 爱心动画核心逻辑
      (function (canvasEl) {
        const ctx = canvasEl.getContext("2d");
        const particles = new ParticlePool(settings.particles.length);
        const particleRate = settings.particles.length / settings.particles.duration; // 每秒粒子数
        let lastTime;

        // 计算爱心曲线上的点（数学公式）
        function pointOnHeart(t) {
          return new Point(160 * Math.pow(Math.sin(t), 3), 130 * Math.cos(t) - 50 * Math.cos(2 * t) - 20 * Math.cos(3 * t) - 10 * Math.cos(4 * t) + 25);
        }

        // 创建粒子图片（用临时canvas绘制爱心形状）
        const particleImage = (function () {
          const tempCanvas = document.createElement("canvas");
          const tempCtx = tempCanvas.getContext("2d");
          tempCanvas.width = settings.particles.size;
          tempCanvas.height = settings.particles.size;

          // 转换爱心曲线坐标到临时canvas
          function to(t) {
            const point = pointOnHeart(t);
            point.x = tempCanvas.width / 2 + (point.x * tempCanvas.width) / 350;
            point.y = tempCanvas.height / 2 - (point.y * tempCanvas.height) / 350;
            return point;
          }

          // 绘制爱心路径
          tempCtx.beginPath();
          let t = -Math.PI;
          let point = to(t);
          tempCtx.moveTo(point.x, point.y);
          while (t < Math.PI) {
            t += 0.01; // 步长越小，爱心越平滑
            point = to(t);
            tempCtx.lineTo(point.x, point.y);
          }
          tempCtx.closePath();

          // 填充爱心颜色（可修改：这里是粉色 #ea80b0）
          tempCtx.fillStyle = "#ea80b0";
          tempCtx.fill();

          // 转换为图片
          const img = new Image();
          img.src = tempCanvas.toDataURL();
          return img;
        })();

        // 渲染函数（核心动画循环）
        function render() {
          requestAnimationFrame(render);
          const newTime = new Date().getTime() / 1000;
          const deltaTime = newTime - (lastTime || newTime);
          lastTime = newTime;

          // 清空画布
          ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

          // 创建新粒子
          const particleAmount = particleRate * deltaTime;
          for (let i = 0; i < particleAmount; i++) {
            const pos = pointOnHeart(Math.PI - 2 * Math.PI * Math.random());
            const dir = pos.clone().length(settings.particles.velocity);
            particles.add(canvasEl.width / 2 + pos.x, canvasEl.height / 2 - pos.y, dir.x, -dir.y);
          }

          // 更新并绘制粒子
          particles.update(deltaTime);
          particles.draw(ctx, particleImage);
        }

        // 窗口 resize 适配
        function onResize() {
          canvasEl.width = canvasEl.clientWidth;
          canvasEl.height = canvasEl.clientHeight;
        }
        window.addEventListener("resize", onResize);

        // 延迟启动（确保DOM完全加载）
        setTimeout(() => {
          onResize();
          render();
        }, 10);
      })(canvas);
    },
  },
};
</script>

<style scoped>
/* 容器样式：全屏 + 黑色背景（原代码样式） */
.love-container {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: #000; /* 背景颜色：可修改为其他颜色（如 #0a192f 深蓝色） */
  position: relative;
}

/* 两个canvas都全屏覆盖，叠加显示 */
#c,
#pinkboard {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
